export default __webpack_public_path__ + "static/media/logo.b988f7be.png";